import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { environment } from 'src/environments/environment';
import { retry , catchError } from 'rxjs/operators';

const getEvaluacion = 'seicep2025/';
const getResultados = 'seicep2025/resultados/';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
  
}; 

@Injectable({
  providedIn: 'root',
})
export class Seicep2025Service {
 

  
  constructor(private http:HttpClient) { }


  getEvaluacion(rbd : string): Observable<any> {
    return this.http.get(environment.apiEndpoint + getEvaluacion + rbd, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  getResultados(rbd: string): Observable<any> {
    return this.http.get(environment.apiEndpoint + getResultados + rbd, httpOptions).pipe(
      catchError(this.handleError)
    );
  }


  handleError(error: any) {
    let errorMessage = '';
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
    return throwError(errorMessage);
  }

}
